import { DocumentType } from '@/features/calendar/types/calendar-dto';
import CurrencyValue from '@/features/finances/components/CurrencyValue';
import { TransactionType } from '@/features/transactions/types/transactions-dto';
import { cn } from '@/lib/utils';
import { CurrencyAssetType } from '@/utils/CurrencyHelper';
import { FC } from 'react';

type Props = {
    id: string;
    apartmentId?: string;
    type?: DocumentType;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    colorClass?: string;
    header: string;
    description: string;
    value: number | string;
    onClick?: (id: string, type?: DocumentType, apartmentId?: string) => void;
    isMobile?: boolean;
    headerClassName?: string;
    descriptionClassName?: string;
    valueClassName?: string;
    asset?: TransactionType;
    currencyAssetType?: CurrencyAssetType;
};

const EActivitiesElement: FC<Props> = ({
    id,
    apartmentId,
    type,
    icon: Icon,
    colorClass,
    header,
    description,
    value,
    onClick,
    isMobile,
    headerClassName,
    descriptionClassName,
    valueClassName,
    asset,
    currencyAssetType
}) => {
    return (
        <article
            className={cn(
                'max-w-[calc(100vw-48px)] -mx-6 px-6 py-4 flex items-center gap-4 hover:bg-primary-color-50 cursor-pointer',
                isMobile && 'max-w-[calc(100vw)] -mx-4 px-4',
            )}
            onClick={() => onClick?.(id, type, apartmentId)}
        >
            <div
                className={`size-8 shrink-0 flex items-center justify-center rounded-semi-xl ${colorClass}`}
            >
                {Icon && <Icon className="fill-inherit" />}
            </div>
            <div className="flex-1 truncate">
                <h4
                    className={cn(
                        'text-base font-medium truncate',
                        isMobile && 'text-sm',
                        headerClassName,
                    )}
                >
                    {header}
                </h4>
                <p className={cn('text-sm text-popover-600 truncate', descriptionClassName)}>
                    {description}
                </p>
            </div>
            <div className={cn('text-sm font-medium shrink-0', valueClassName)}>
                <CurrencyValue
                    value={value}
                    asset={
                        asset !== undefined
                            ? (TransactionType[asset].toLowerCase() as CurrencyAssetType)
                            : currencyAssetType
                    }
                    addStyles={true}
                />
            </div>
        </article>
    );
};

export default EActivitiesElement;
